import React from 'react'

export const CircularTickIcon: React.FC = () => {
	return (
		<svg
			id='check_2_'
			data-name='check (2)'
			xmlns='http://www.w3.org/2000/svg'
			width='26.611'
			height='26.611'
			viewBox='0 0 26.611 26.611'>
			<g id='Group_4975' data-name='Group 4975'>
				<path
					id='Path_3585'
					data-name='Path 3585'
					d='M13.306,0A13.306,13.306,0,1,0,26.611,13.306,13.306,13.306,0,0,0,13.306,0ZM11.4,19.123l-5.76-5.76,2.016-2.016L11.4,15.091l7.07-7.07,2.016,2.016Z'
					fill='#ff3067'
				/>
			</g>
		</svg>
	)
}

export const NotificationAlertIcon: React.FC = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='28.606'
		height='25.246'
		viewBox='0 0 28.606 25.246'>
		<g
			id='_006-rocket'
			data-name='006-rocket'
			transform='translate(4.597 1.755)'>
			<g id='caution' transform='translate(-4.597 -1.756)'>
				<path
					id='Subtraction_25'
					data-name='Subtraction 25'
					d='M25.926,25.246H2.68A2.675,2.675,0,0,1,.37,21.222l11.623-19.9a2.676,2.676,0,0,1,4.621,0l11.623,19.9a2.675,2.675,0,0,1-2.31,4.024ZM14.3,1.431a1.225,1.225,0,0,0-1.075.617L1.6,21.943a1.245,1.245,0,0,0,1.074,1.873H25.926A1.245,1.245,0,0,0,27,21.943L15.378,2.047A1.224,1.224,0,0,0,14.3,1.431ZM25,22.386H3.61a.349.349,0,0,1-.3-.525L14,3.558a.349.349,0,0,1,.6,0L25.3,21.861a.349.349,0,0,1-.3.525Zm-10.644-4.16a1.053,1.053,0,0,0-.707.25.773.773,0,0,0-.29.605.783.783,0,0,0,.29.6,1.037,1.037,0,0,0,.707.257.886.886,0,0,0,.632-.257.809.809,0,0,0,.267-.6.8.8,0,0,0-.267-.605A.9.9,0,0,0,14.353,18.226Zm-.018-9.861a1,1,0,0,0-.64.2.679.679,0,0,0-.247.561c0,.755.031,2,.093,3.713s.094,2.951.094,3.714c0,.335.236.505.7.505a.88.88,0,0,0,.461-.134.415.415,0,0,0,.222-.371c0-.746.013-1.961.039-3.713S15.1,9.87,15.1,9.124a.794.794,0,0,0-.183-.553A.745.745,0,0,0,14.335,8.365Z'
					transform='translate(0 0)'
					fill='#7a719b'
				/>
			</g>
		</g>
	</svg>
)

export const NotificationCircularStopSignIcon: React.FC = () => (
	<svg
		id='no-stopping'
		xmlns='http://www.w3.org/2000/svg'
		width='26.611'
		height='26.611'
		viewBox='0 0 26.611 26.611'>
		<g id='Group_4976' data-name='Group 4976' transform='translate(0)'>
			<path
				id='Path_3586'
				data-name='Path 3586'
				d='M13.306,0A13.306,13.306,0,1,0,26.611,13.306,13.321,13.321,0,0,0,13.306,0Zm0,23.285a9.991,9.991,0,0,1-9.979-9.979,9.851,9.851,0,0,1,1.847-5.78L19.085,21.438A9.851,9.851,0,0,1,13.306,23.285Zm8.132-4.2L7.526,5.174a9.851,9.851,0,0,1,5.78-1.847,9.991,9.991,0,0,1,9.979,9.979A9.851,9.851,0,0,1,21.438,19.085Z'
				transform='translate(0)'
				fill='#7a719b'
			/>
		</g>
	</svg>
)
